import { createRoute, redirect } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

/**
 * FKS-8676 renamed the admin Kopilot pages from `/real_invoices` to
 * `/kopilot/invoices`. Kept reachable so existing deep links keep working.
 */

const legacyPath = '/real_invoices';
const currentPath = '/kopilot/invoices';

const adminInvoicesRedirectRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: legacyPath,
  beforeLoad: ({ location }) => {
    throw redirect({ href: location.href.replace(legacyPath, currentPath) });
  },
});

const adminInvoiceRedirectRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: `${legacyPath}/$id`,
  params: z.object({ id: zodPathParamId }),
  beforeLoad: ({ location }) => {
    throw redirect({ href: location.href.replace(legacyPath, currentPath) });
  },
});

export const legacyAdminKopilotRedirectRoutes = [
  adminInvoicesRedirectRoute,
  adminInvoiceRedirectRoute,
];
